import { generateId } from '@freelancer/datastore/testing';
import { DepositMethodApi } from 'api-typings/common/common';
import {
  PaymentShareEntityTypeApi,
  PaymentShareSpendingLimitDurationApi,
  PaymentShareTeamStatusApi,
} from 'api-typings/users/users';
import { PaymentShareTeam } from './payment-share-teams.model';

export interface GeneratePaymentShareTeamOptions {
  readonly ownerEntityId: number;
  readonly ownerEntityType?: PaymentShareEntityTypeApi;
  readonly paymentShareTeamName?: string;
  readonly status?: PaymentShareTeamStatusApi;
  readonly memberSpendingLimitDuration?: PaymentShareSpendingLimitDurationApi;
  readonly memberSpendingLimitAmount?: number;
  readonly isSpendingLimitActive?: boolean;
  readonly billingAgreementId?: number;
  readonly depositMethod?: DepositMethodApi;
}

/** Returns a payment share team object. */
export function generatePaymentShareTeamObject({
  ownerEntityId,
  ownerEntityType = PaymentShareEntityTypeApi.USER,
  paymentShareTeamName = 'The Payment Share Team Name',
  status = PaymentShareTeamStatusApi.ENABLED,
  memberSpendingLimitDuration = PaymentShareSpendingLimitDurationApi.NO_TIME_LIMIT,
  memberSpendingLimitAmount = 0,
  isSpendingLimitActive = false,
  billingAgreementId = 1,
  depositMethod = DepositMethodApi.DEV_CREDITS,
}: GeneratePaymentShareTeamOptions): PaymentShareTeam {
  return {
    id: generateId(),
    ownerEntityId,
    ownerEntityType,
    paymentShareTeamName,
    status,
    memberSpendingLimitDuration,
    memberSpendingLimitAmount,
    isSpendingLimitActive,
    isTeamOwner: true,
    billingAgreementId,
    depositMethod,
  };
}
